import styled, { css } from 'styled-components';

import { FlatButton } from '@ui/buttons/Button.tsx';
import { Icon } from '@ui/icons/Icon.tsx';

import { ANIMATION_TIME, ANIMATION_DELAY } from '../constants.ts';

export const RouteTypeInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  margin: auto;
  ${({ theme }) => theme.fontSize('14px')};
  background-color: var(--color-widgetIconFill);
  color: var(--color-widgetBackground);
  ${({ theme }) => theme.borderRadius(8)};

  ${Icon} {
    fill: var(--color-widgetBackground);
    margin-inline-end: 2px;
    position: relative;
    inset-inline-end: 6px;
  }
`;

export const WarningTheme = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  margin: auto;
  ${({ theme }) => theme.fontSize('14px')};
  background-color: var(--color-statusWarningBackground);
  color: var(--color-widgetBackground);
  ${({ theme }) => theme.borderRadius(8)};

  ${Icon} {
    fill: var(--color-widgetBackground);
    margin-inline-end: 2px;
    position: relative;
    inset-inline-end: 6px;
  }
`;

export const RouteTypeButton = styled(FlatButton)`
  flex: 1 0 50%;
  padding: 3px 0;
  margin: 0;
  color: ${({ active }) => (active ? 'var(--color-widgetBackground)' : 'var(--color-widgetIconFill)')} !important;
  background-color: ${({ active }) => (active ? 'var(--color-widgetIconFill)' : 'transparent')} !important;
  ${({ theme }) => theme.borderRadius(8)};
  z-index: ${({ active }) => (active ? '1' : '0')};
  position: relative;
  ${({ theme }) => theme.fontSize('14px')};

  ${Icon} {
    fill: ${({ active }) => (active ? 'var(--color-widgetBackground)' : 'var(--color-widgetIconFill)')} !important;
  }

  &:focus,
  &:active,
  &:hover {
    background-color: ${({ active }) => (active ? 'var(--color-widgetIconFill)' : 'transparent')} !important;
    color: ${({ active }) => (active ? 'var(--color-widgetBackground)' : 'var(--color-widgetIconFill)')} !important;
    ${Icon} {
      fill: ${({ active }) => (active ? 'var(--color-widgetBackground)' : 'var(--color-widgetIconFill)')} !important;
    }
  }

  &:hover {
    &::before {
      background-color: ${({ active }) => (active ? 'unset' : 'var(--color-widgetText-25)')};
    }
  }

  &:first-child::before {
    inset-inline-end: ${({ active }) => (active ? '0' : 'auto')};
    inset-inline-start: ${({ active }) => (active ? 'auto' : '0')};
  }

  &::before {
    ${({ theme }) => theme.borderRadius(8)};
    position: absolute;
    content: '';
    width: calc(100% + 14px);
    inset-inline-end: 0;
    height: 100%;
    background-color: transparent;
  }
`;

export const LevelInfo = styled.div`
  position: absolute;
  transform: translateY(100%);
  bottom: -8px;
  margin: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;

  animation: fade-out ${ANIMATION_TIME}s forwards;
  animation-delay: ${ANIMATION_DELAY}s;

  @keyframes fade-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @-webkit-keyframes fade-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  span {
    padding: 7px 12px;
    text-align: center;
    background-color: rgba(32, 37, 48, 0.95);
    width: auto;
    max-width: 60%;
    ${({ theme }) => theme.fontSize('14px')};
    color: #fff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    ${({ theme }) => theme.borderRadius('2')};
  }
`;

export const TopButtons = styled.div`
  display: flex;
  margin-bottom: 14px;

  div,
  button {
    text-align: center;
    user-select: none;
    color: var(--color-widgetIconFill);
    ${({ theme }) => theme.fontSize('12px')};
    cursor: pointer;
    position: relative;

    &:last-child {
      margin-inline-start: auto;
      position: relative;
    }

    &:hover > .tooltip {
      display: block;
      position: absolute;
      color: #fff;
      margin: 0 4px;
    }
  }

  button {
    background-color: transparent;
    border: none;
  }
`;

export const InputsFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 12px 4px 12px;
`;

export const directionsHeaderSpacing = css`
  padding-inline: 16px;

  ${InputsFooter} {
    padding-inline: 0;

    button {
      padding-inline: 0;
    }
  }
`;
